<div class="how-to">
  <h2>How To</h2>
  @if (canCreateTutorials$ | async) {
    <button mat-stroked-button class="how-to__new-tutorial" (click)="newTutorial()">
      New tutorial
      <mat-icon>add</mat-icon>
    </button>
  }
  <mat-form-field class="how-to__filter">
    <mat-label>Search tutorials</mat-label>
    <input matInput [formControl]="searchControl" />
    @if (searchControl.value) {
      <mat-icon matSuffix (click)="clearSearch()" style="cursor: pointer">close</mat-icon>
    }
  </mat-form-field>

  <app-tags-list (tagSelected)="selectedTag = $event"></app-tags-list>
  <app-latest-tutorials [hidden]="selectedTag || filter"></app-latest-tutorials>
  <app-tutorial-list [selectedTag]="selectedTag" [searchTerm]="filter"></app-tutorial-list>
</div>
